module.exports = __webpack_public_path__ + "img/HomePage-industries.6e8e556.webp";